var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/processor/JSObjectEventProcessor.ts
import {
  simple_hash
} from "ethereum-indexer";
import { logs } from "named-logs";

// src/processor/immer.ts
var immer_exports = {};
__reExport(immer_exports, immer_star);
import { enablePatches } from "immer";
import * as immer_star from "immer";
enablePatches();

// src/processor/history.ts
var History = class {
  constructor(historyJSON) {
    this.historyJSON = historyJSON;
  }
  setFinality(finality) {
    this.finality = finality;
  }
  setBlock(blockNumber, blockHash) {
    if (!this.finality) {
      throw new Error(`finality not set`);
    }
    this.blockNumber = blockNumber;
    this.blockHash = blockHash;
    for (const key of Object.keys(this.historyJSON.blockHashes)) {
      if (blockNumber - parseInt(key) > this.finality) {
        const blockHash2 = this.historyJSON.blockHashes[parseInt(key)];
        delete this.historyJSON.reversals[blockHash2];
        delete this.historyJSON.blockHashes[parseInt(key)];
      }
    }
    this.historyJSON.blockHashes[blockNumber] = blockHash;
  }
  reverseBlock(blockNumber, blockHash, json) {
    if (!this.blockHash) {
      throw new Error(`no blockhash set`);
    }
    const patches = this.historyJSON.reversals[blockHash];
    for (let i = patches.length - 1; i >= 0; i--) {
      json = (0, immer_exports.applyPatches)(json, patches[i]);
    }
    delete this.historyJSON.reversals[blockHash];
    delete this.historyJSON.blockHashes[blockNumber];
    return json;
  }
  setReversal(patches) {
    if (!this.blockHash) {
      throw new Error(`no blockhash set`);
    }
    this.historyJSON.reversals[this.blockHash] = this.historyJSON.reversals[this.blockHash] || [];
    this.historyJSON.reversals[this.blockHash].push(patches);
  }
};

// src/processor/JSObjectEventProcessor.ts
var immer = new immer_exports.Immer({ autoFreeze: false });
var namedLogger = logs("JSObjectEventProcessor");
var JSObjectEventProcessor = class {
  constructor(singleEventProcessor) {
    this.singleEventProcessor = singleEventProcessor;
    this.version = singleEventProcessor.version;
    const state = singleEventProcessor.createInitialState();
    const history = {
      blockHashes: {},
      reversals: {}
    };
    this._json = {
      state,
      lastSync: void 0,
      history
    };
    this.history = new History(history);
  }
  copyFrom(otherProcessor) {
    this._json = otherProcessor._json;
    this.history = otherProcessor.history;
    this.keeper = otherProcessor.keeper;
    this.source = otherProcessor.source;
    this.config = otherProcessor.config;
    this.configHash = otherProcessor.configHash;
    this.singleEventProcessor.configure(this.config);
    this.finality = otherProcessor.finality;
  }
  getVersionHash() {
    return `${this.version || "unknown"}-${this.configHash || "not-configured"}`;
  }
  createInitialState() {
    return this.singleEventProcessor.createInitialState();
  }
  configure(config) {
    this.config = config;
    this.singleEventProcessor.configure(config);
    this.configHash = simple_hash(this.config);
  }
  keepState(keeper) {
    this.keeper = keeper;
  }
  async reset() {
    namedLogger.info("JSObjectEventProcessor reseting...");
    const state = this.singleEventProcessor.createInitialState();
    this.version = this.singleEventProcessor.version;
    const history = {
      blockHashes: {},
      reversals: {}
    };
    this._json = {
      state,
      lastSync: void 0,
      history
    };
    this.history = new History(history);
    if (this.finality) {
      this.history.setFinality(this.finality);
    }
  }
  async clear() {
    if (this.keeper) {
      const config = this.config;
      const source = this.source;
      const version = this.version;
      const context = { source, config, version };
      await this.keeper.clear(context);
    }
    return this.reset();
  }
  async load(source, streamConfig) {
    this.finality = streamConfig.finality;
    this.history.setFinality(this.finality);
    this.source = source;
    if (this.keeper) {
      const config = this.config;
      const version = this.version;
      const context = { source, config, version };
      const existingStateData = await this.keeper.fetch(context);
      if (existingStateData) {
        const { lastSync: lastSyncFromExistingState, state, history } = existingStateData;
        if (!this._json.lastSync?.lastToBlock || // TODO configure 100
        Math.max(0, lastSyncFromExistingState.lastToBlock - this._json.lastSync?.lastToBlock || 0) > 100) {
          this._json.history = history;
          this.history.setBlock(0, "0x0000");
          this._json.state = state;
          this._json.lastSync = lastSyncFromExistingState;
        }
      }
    }
    if (!this._json.lastSync) {
      return void 0;
    }
    if (!this._json.state) {
      throw new Error(`no data`);
    }
    return { lastSync: this._json.lastSync, state: this._json.state };
  }
  async process(eventStream, lastSync) {
    let draft;
    if (!this.finality) {
      throw new Error(`finality not set`);
    }
    if (!this._json.state) {
      throw new Error(`no data`);
    }
    const willNotChange = lastSync.latestBlock - lastSync.lastToBlock > this.finality;
    try {
      let lastBlock;
      let lastBlockHash;
      let lastBlockDeleted;
      for (const event of eventStream) {
        if (event.removed) {
          namedLogger.info(`JSObjectEventProcessor event removed....`);
          if (!lastBlockDeleted || event.blockHash != lastBlockDeleted) {
            namedLogger.info(`JSObjectEventProcessor preparing block...`);
            this._json.state = this.history.reverseBlock(event.blockNumber, event.blockHash, this._json.state);
            lastBlockDeleted = event.blockHash;
          }
        } else {
          if (willNotChange) {
            await this.singleEventProcessor.processEvent(this._json.state, event);
          } else {
            if (!lastBlockHash || event.blockHash != lastBlockHash) {
              if (draft) {
                const finalizedDraft = immer.finishDraft(draft, (_, reversePatches) => {
                  this.history.setReversal(reversePatches);
                });
                this._json.state = finalizedDraft;
              }
              this.history.setBlock(event.blockNumber, event.blockHash);
              lastBlock = event.blockNumber;
              lastBlockHash = event.blockHash;
              draft = immer.createDraft(this._json.state);
            }
            this.singleEventProcessor.processEvent(draft, event);
          }
        }
      }
      if (draft) {
        const finalizedDraft = immer.finishDraft(draft, (_, reversePatches) => {
          this.history.setReversal(reversePatches);
        });
        this._json.state = finalizedDraft;
      }
      let lastLastSync;
      try {
        lastLastSync = this._json.lastSync;
      } catch (err) {
      }
      const lastSyncDoc = {
        _id: "lastSync",
        _rev: lastLastSync?._rev,
        ...lastSync
      };
      this._json.lastSync = lastSyncDoc;
      if (this.keeper) {
        try {
          const config = this.config;
          const source = this.source;
          const version = this.version;
          const context = { source, config, version };
          if (!this._json.state || !this._json.lastSync || !this._json.history) {
            throw new Error(`empty _json`);
          }
          await this.keeper.save(context, this._json);
        } catch (e) {
          namedLogger.error(`failed to save ${e}`);
        }
      }
    } finally {
    }
    if (!this._json.state) {
      throw new Error(`empty _json`);
    }
    return this._json.state;
  }
};

// src/processor/utils.ts
var SingleJSONEventProcessorWrapper = class {
  constructor(obj) {
    this.obj = obj;
    this.version = obj.version;
  }
  createInitialState() {
    return this.obj.construct();
  }
  configure(config) {
    this.config = config;
  }
  processEvent(json, event) {
    if ("decodeError" in event) {
      if (this.obj.handleUnparsedEvent) {
        return this.obj.handleUnparsedEvent(json, event);
      }
      return;
    }
    const functionName = `on${event.eventName}`;
    if (this.obj[functionName]) {
      return this.obj[functionName](json, event, this.config);
    }
  }
  construct() {
    if (this.obj.construct) {
      return this.obj.construct();
    }
    return void 0;
  }
};
function fromJSProcessor(v) {
  return () => {
    return new JSObjectEventProcessor(
      new SingleJSONEventProcessorWrapper(typeof v === "function" ? v() : v)
    );
  };
}
export {
  JSObjectEventProcessor,
  fromJSProcessor
};
